import { Box } from "@mui/material"
import TopUpCredit from "../components/TopUpCredit"

const RecruitmentTopUpCredit=()=>{
    return(
        <Box>
            <TopUpCredit/>
        </Box>
    )
}
export default RecruitmentTopUpCredit